import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import Confetti from "react-confetti";

const CustomConfetti = () => {
  const confettiSource = {
    x: 0,
    y: 0,
    w: window.innerWidth,
    h: window.innerHeight / 2,
  };
  const initialVelocityX = 0;
  const initialVelocityY = -10;
  return (
    <>
      {/* Default - circles and strips */}
      <Confetti
        confettiSource={confettiSource}
        numberOfPieces={50}
        initialVelocityY={initialVelocityY}
        initialVelocityX={initialVelocityX}
      />

      {/* Spirals */}
      <Confetti
        confettiSource={confettiSource}
        numberOfPieces={50}
        initialVelocityY={initialVelocityY}
        initialVelocityX={initialVelocityX}
        drawShape={(ctx) => {
          ctx.beginPath();
          for (let i = 0; i < 22; i += 1) {
            const angle = 0.35 * i;
            const x = (0.2 + 1.5 * angle) * Math.cos(angle);
            const y = (0.2 + 1.5 * angle) * Math.sin(angle);
            ctx.lineTo(x, y);
          }
          ctx.stroke();
          ctx.closePath();
        }}
      />

      {/* Circles */}
      <Confetti
        confettiSource={confettiSource}
        initialVelocityY={initialVelocityY}
        initialVelocityX={initialVelocityX}
        numberOfPieces={50}
        drawShape={(context) => {
          context.beginPath();
          context.arc(0, 0, 5, 0, 2 * Math.PI);
          context.fill();
        }}
      />

      {/* Triangles */}
      <Confetti
        confettiSource={confettiSource}
        initialVelocityY={initialVelocityY}
        initialVelocityX={initialVelocityX}
        numberOfPieces={50}
        drawShape={(context) => {
          context.beginPath();
          context.moveTo(0, -5);
          context.lineTo(5, 5);
          context.lineTo(-5, 5);
          context.closePath();
          context.fill();
        }}
      />

      {/* Stars */}
      <Confetti
        confettiSource={confettiSource}
        numberOfPieces={50}
        initialVelocityY={initialVelocityY}
        initialVelocityX={initialVelocityX}
        gravity={0.03}
        drawShape={(ctx) => {
          const spikes = 5;
          const outerRadius = 10;
          const innerRadius = 5;
          let rotation = (Math.PI / 2) * 3;
          const centerX = 0;
          const centerY = 0;

          ctx.beginPath();
          ctx.moveTo(centerX, centerY - outerRadius);

          for (let i = 0; i < spikes; i += 1) {
            const x = centerX + Math.cos(rotation) * outerRadius;
            const y = centerY + Math.sin(rotation) * outerRadius;
            ctx.lineTo(x, y);
            rotation += Math.PI / spikes;

            const innerX = centerX + Math.cos(rotation) * innerRadius;
            const innerY = centerY + Math.sin(rotation) * innerRadius;
            ctx.lineTo(innerX, innerY);
            rotation += Math.PI / spikes;
          }

          ctx.lineTo(centerX, centerY - outerRadius);
          ctx.closePath();
          ctx.fill();
        }}
      />
    </>
  );
};

export default CustomConfetti;
